import { all } from "redux-saga/effects";

import { questionaireSagas } from "./questionaireSaga";
import { authSagas } from "./authSaga";
import { workItemsSagas } from "./workItemsSaga";
import { SummarySagas } from "./summarySaga";
import { messageSagas } from "./messageSaga";
import { changePasswordSagas } from "./changePasswordSaga";
import { changeRoleSagas } from "./changeRoleSaga";
import { reportSagas } from "./reportSaga";
import sanitizeSagas from "./sanitizeSaga";
import paginationSagas from "store/common/pagination/sagas";
import sortingSagas from "store/common/sorting/sagas";
import workListColumnsSagas from "./workListColumnsSaga";
import userSagas from "./userSaga";

function* rootSaga() {
  yield all([
    ...questionaireSagas,
    ...authSagas,
    ...workItemsSagas,
    ...SummarySagas,
    ...messageSagas,
    ...changePasswordSagas,
    ...reportSagas,
    ...sanitizeSagas,
    ...paginationSagas,
    ...sortingSagas,
    ...workListColumnsSagas,
    ...userSagas,
    ...changeRoleSagas
  ]);
}

export default rootSaga;
